import { render } from "./SubscriptionList.vue?vue&type=template&id=68022f37&scoped=true"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"

import "./SubscriptionList.vue?vue&type=style&index=0&id=68022f37&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68022f37"]])

export default __exports__